export const ROUTES = {
  ROOT: '/' as const,
  LOGIN: '/login' as const,
  LOGIN_APPLICANT: '/login-applicant' as const,
  FORGOT_PASSWORD: '/forgot-password' as const,
  CHANGE_PASSWORD: '/change-password' as const,
  LOGOUT: '/logout' as const,
  MAINTENANCE: '/maintenance' as const,
  CLOUD_PAYMENTS: '/cloud_payments/:checkoutId' as const,
  PAYMENT_PLAN: '/payment-plan' as const,
  PAYMENT_PLAN_PURPOSE: '/payment-plan/plan-purpose' as const,
  PAYMENT_PLAN_CUSTOMER_DETAILS: '/payment-plan/customer-details' as const,
  PAYMENT_PLAN_HOUSEHOLD_EXPENSES: '/payment-plan/household-expenses' as const,
  PAYMENT_PLAN_BANK_STATEMENTS: '/payment-plan/bank-statements' as const,
  PAYMENT_PLAN_BANK_STATEMENTS_ONLINE_BANKING:
    '/payment-plan/bank-statements/online-banking' as const,
  PAYMENT_PLAN_BANK_STATEMENTS_PDF_INSTRUCTIONS:
    '/payment-plan/bank-statements/pdf-instructions' as const,
  PAYMENT_PLAN_BANK_STATEMENTS_PDF_UPLOAD: '/payment-plan/bank-statements/pdf-upload' as const,
  PAYMENT_PLAN_CUSTOMER_CONSENT: '/payment-plan/summary' as const, // TODO: Change to customer-consent
  PAYMENT_PLAN_PAYMENT: '/payment-plan/payment' as const,
  PAYMENT_PLAN_RESULT: '/payment-plan/plan-result' as const,
  PAYMENT_PLAN_CONTRACT: '/payment-plan/contract' as const,
  ERROR: '/error' as const,
} as const;

export type Routes = typeof ROUTES;
export type RoutePath = Routes[keyof Routes];
